import type { UnderlyingCodeType } from 'models/underlying/base';
import { createContext } from 'react';

export const UnderlyingCodeTypeContext = createContext<UnderlyingCodeType>('Bloomberg');
